(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mivra-related"] && !Shopify.designMode) return;
  try {
    
let mivraRelatedRequest;
async function refreshMivraRelated(event){
 const root=document.querySelector('[data-mivra-related][data-page-type="cart"]');
 if(!root||!event.promise?.then)return;
 try{
  await event.promise;
  mivraRelatedRequest?.abort();
  const controller=new AbortController();mivraRelatedRequest=controller;
  const url=new URL(root.dataset.cartUrl,window.location.origin);
  url.searchParams.set('section_id',root.dataset.mivraRelated);
  const response=await fetch(url,{signal:controller.signal});
  if(!response.ok)return;
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');
  const replacement=doc.querySelector('[data-mivra-related]');
  if(replacement&&!controller.signal.aborted)root.replaceWith(replacement);
 }catch(error){if(error.name!=='AbortError')console.warn('Related products could not refresh');}
}
document.addEventListener('shopify:cart:lines-update',refreshMivraRelated);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mivra-shipping"] && !Shopify.designMode) return;
  try {
    
function updateMivraShipping(cart){
 const total=typeof cart.total_price==='number'?cart.total_price:Math.round(Number(cart.cost?.totalAmount?.amount||0)*100);
 document.querySelectorAll('[data-mivra-shipping]').forEach(root=>{
  const texts=JSON.parse(root.querySelector('[data-shipping-text]').textContent);const remaining=Math.max(0,75000-total);
  const amount=(remaining/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' TL';
  root.querySelector('[data-shipping-message]').textContent=total>=75000?texts.earned:total===0?texts.empty:texts.remaining.replace('__AMOUNT__',amount);
  root.querySelector('progress').value=Math.min(75000,total);
 });
}
function receiveMivraCart(event){if(event.promise?.then)event.promise.then(result=>{if(result?.cart)updateMivraShipping(result.cart)}).catch(()=>{});}
document.addEventListener('shopify:cart:lines-update',receiveMivraCart);document.addEventListener('shopify:cart:discount-update',receiveMivraCart);

  } catch(e) { console.error(e); }
})();
})();
